import React, { useRef, useEffect } from "react";
import style from "./SwitchTabs.module.scss";
import AppTooltip from "../AppTooltip/AppTooltip";

const SwitchTabs = ({ options, activeOption, onOptionChange, className = "" }) => {
  const containerRef = useRef(null);
  const indicatorRef = useRef(null);
  const buttonRefs = useRef({});

  const updateIndicatorPosition = () => {
    const activeButton = buttonRefs.current[activeOption];
    const indicator = indicatorRef.current;

    if (activeButton && indicator) {
      const buttonRect = activeButton.getBoundingClientRect();
      const containerRect = containerRef.current.getBoundingClientRect();

      const leftOffset = buttonRect.left - containerRect.left;
      const width = buttonRect.width;

      indicator.style.transform = `translateX(${leftOffset}px)`;
      indicator.style.width = `${width}px`;
    }
  };

  useEffect(() => {
    const timer = setTimeout(updateIndicatorPosition, 0);
    return () => clearTimeout(timer);
  }, [activeOption]);

  useEffect(() => {
    const handleResize = () => updateIndicatorPosition();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleOptionClick = (optionKey) => {
    onOptionChange(optionKey);
  };

  return (
    <div ref={containerRef} className={`${style.toggleContainer} ${className}`}>
      <div ref={indicatorRef} className={style.toggleIndicator} />

      {options.map((option) => (
        <React.Fragment key={option.key}>
          <button
            ref={(el) => (buttonRefs.current[option.key] = el)}
            className={`${style.toggleButton} ${activeOption === option.key ? style.active : ""}`}
            onClick={() => handleOptionClick(option.key)}
            data-tooltip-id={option.tooltip ? `switch-tab-tooltip-${option.key}` : undefined}
          >
            {option.icon && <span className={style.buttonIcon}>{option.icon}</span>}
            {option.text}
          </button>
          {option.tooltip && (
            <AppTooltip id={`switch-tab-tooltip-${option.key}`} place="bottom" positionStrategy="fixed">
              {option.tooltip}
            </AppTooltip>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default SwitchTabs;
